export const text = {
  NO_RESULTS: 'No results',
  CODES_ADDED: 'Codes added',
}
